// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"SocialIcon_socialIcon_R3o10","fb":"SocialIcon_fb_14xhv","tw":"SocialIcon_tw_uof0n","ig":"SocialIcon_ig_3AMxy"};